import Collapse from './Collapse';
export default Collapse;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/collapse/index.js
// module id = 776
// module chunks = 3